import { time } from "../utils/time";
import { TEAM_IDS } from "./TeamIds";

export const TEAM_TIMEOUT_OVERRIDES_IN_MS: Record<string, number | null> = {
  [TEAM_IDS.WYND_LABS_GRASS]: time.minutesToMilliseconds(10),
};
